import { formFieldTypographySx } from './formFieldVariants';
import type { SxProps, Theme } from './types';

export const formFieldLabelSx: SxProps<Theme> = formFieldTypographySx;
